import React from "react";
import {useTranslation} from "react-i18next";
import {hasAnyRole, isAdmin, isAuthenticated, isCompanyAdmin, isTraCertAdmin, permissions} from "../../hooks/user";
import {LinkBlock} from "./LinkBlock";
import {
    Award,
    Briefcase,
    Command,
    Grid,
    Key,
    Maximize,
    PieChart,
    PlusSquare,
    Sliders,
    User,
    Users
} from "react-feather";

export function MainMenu() {
    const {t} = useTranslation();

    return (<>
        <ul className={'link-blocks'}>
            <LinkBlock className={'accent7-background'} url={'/dashboard'} title={t('menu.dashboard')}
                       icon={<Command height={48} width={48}/>}/>
            <LinkBlock className={'accent7-background'} url={'/scan'} title={t('menu.scan')}
                       icon={<Maximize height={48} width={48}/>}/>
            {isAuthenticated() &&
            <LinkBlock className={'accent7-background'} url={'/profile'} title={t('menu.profile')}
                       icon={<User height={48} width={48}/>}/>
            }
            {!isAuthenticated() &&
            <LinkBlock className={'accent7-background'} url={'/login'} title={t('menu.login')}
                       icon={<Key height={48} width={48}/>}/>
            }
            {hasAnyRole(permissions.manageCertificates) && <>
              <LinkBlock className={'accent7-background'} url={'/certificates'} title={t('menu.certificates')}
                         icon={<Award height={48} width={48}/>}/>
              <LinkBlock className={'accent7-background'} url={'/certificates/add'} title={t('menu.addCertificate')}
                         icon={<PlusSquare height={48} width={48}/>}/>
            </>}
            {isAdmin() && <>
              <LinkBlock className={'accent7-background'} url={'/users'} title={t('menu.users')}
                         icon={<Users height={48} width={48}/>}/>
            </>}
            {isCompanyAdmin() &&
            <LinkBlock className={'accent7-background'} url={'/company'} title={t('menu.company')}
                       icon={<Briefcase height={48} width={48}/>}/>
            }
            {isTraCertAdmin() && <>
              <LinkBlock className={'accent7-background'} url={'/companies'} title={t('menu.companies')}
                         icon={<Briefcase height={48} width={48}/>}/>
              <LinkBlock className={'accent7-background'} url={'/templates'} title={t('menu.templates')}
                         icon={<Grid height={48} width={48}/>}/>
              <LinkBlock className={'accent7-background'} url={'/businessSectors'} title={t('menu.businessSectors')}
                         icon={<PieChart height={48} width={48}/>}/>
              <LinkBlock className={'accent7-background'} url={'/billingSettings'} title={t('menu.billingSettings')}
                         icon={<Sliders height={48} width={48}/>}/>
            </>}
        </ul>
    </>)
}
